import type { Dispatch, Middleware, MiddlewareAPI, PayloadAction } from '@reduxjs/toolkit';
import { isRejectedWithValue } from '@reduxjs/toolkit';

import type { RootState } from '../store';
import { setSessionExpired } from './slices/global';

interface DefaultActionPayload {
  data?: {
    error_code?: number;
  };
}

type Action = PayloadAction<DefaultActionPayload> | PayloadAction<string>;

export const rtkQueryErrorLogger: Middleware<{ api: MiddlewareAPI<Dispatch<Action>, RootState> }, RootState> =
  (api) => (next) => (action) => {
    if (isRejectedWithValue(action)) {
      const sessionErrorMessage = 'CASHIER.PH2.ERROR_MESSAGE.17';
      const { error_code } = (action.payload as DefaultActionPayload)?.data || {};
      const sessionExpiredError = error_code === 17 || sessionErrorMessage === action.payload;

      if (sessionExpiredError) {
        api.dispatch(setSessionExpired());
      }
    }

    return next(action);
  };
